/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_PaymentInputs */

const vi_receipt_label_payment = /** @type {(inputs: Receipt_Label_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình thức thanh toán`)
};

/**

* @param {Receipt_Label_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_payment = /** @type {((inputs?: Receipt_Label_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_payment(inputs)
});